import { fetchWithErrorHandling, buildPostOptions } from "../FetchUtils";
import { useAuthUser } from "react-auth-kit";

export const createOrUpdateCwDashboard = async (accessToken: string, baseURL: string, name: string) => {
  return fetchWithErrorHandling(
    baseURL + "v1/observability/create-or-update-cw-dashboard",
    buildPostOptions(accessToken, { name }),
  );
};

export const useObservabilityService = () => {
  const authUser = useAuthUser();
  const accessToken = authUser()?.access_token;

  return {
    createOrUpdateCwDashboard: (baseUrl: string, name: string) => createOrUpdateCwDashboard(accessToken, baseUrl, name),
  };
};
